import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const sharedCookie = getCookieByName(sharedCookieKey);

        if (jwtFromCookie && sharedCookie) {
            const wholeTokenFromCookie = JSON.parse(sharedCookie);

            let spatFromCookie = wholeTokenFromCookie.spat;

            let result = await apiClient(config).apiMethod({
                method: 'SendRafInvite',
                headers: {
                    'X-Auth-Token': jwtFromCookie,
                    'X-Auth-Spat': spatFromCookie,
                },
                args: {
                    // not firstName could also be sent, but is not being utilized by MO.
                    email: payload.email,
                },
            });
            // a result.code is returned either way, if error its an error code, if success
            // it's the RAF code, so check the created_at field which only shows on success.
            return {
                ...result,
                success: result.created_at ? true : false,
                error: result.created_at ? {} : result,
            };
        }
    };
};
